/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import AddNoteAction from './AddNoteAction/index'
import BlockTimeAction from './BlockTimeAction/index'
import OverrideChairScheduleAction from './OverrideChairScheduleAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/SlotDialog/Content/Actions"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Actions.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<AddNoteAction
  viewPath={`${viewPath}/AddNoteAction`}
/>
<BlockTimeAction
  viewPath={`${viewPath}/BlockTimeAction`}
/>
<OverrideChairScheduleAction
  viewPath={`${viewPath}/OverrideChairScheduleAction`}
/>
</div>
{children}
</React.Fragment>)
}